export { default } from './BundleConsoleBase';
